export class Patient {
    patientId: string;
    streetAddressNameNumberAndLetter: string;
    addressDescription: string;
    zipCode: string;
    patientName: string;
    addressIsPermanent: boolean;
    primaryContactId: string;
    secondaryContactId: string;

    // additional properties for managing state
    zipCodeSuggestion: string;
    zipCodeWarning: boolean;
    addressValid: boolean;
    feasibilityError: boolean;
    tasksFeasibilityErrorCount: number;
    feasibilityWarning: boolean;
    tasksFeasibilityWarningCount: number;
    addressUpdating: boolean;
    taskUpdating: boolean;
    feasibilityReloading: boolean;
    selected: boolean;

    constructor(patientId: string, streetAddressNameNumberAndLetter: string, zipCode: string, patientName: string) {
        this.patientId = patientId;
        this.streetAddressNameNumberAndLetter = streetAddressNameNumberAndLetter;
        this.zipCode = zipCode;
        this.patientName = patientName;
    }
}
